export const ESTIMATE_STATUS_OPTIONS = [
  { value: "Chờ duyệt", label: "Chờ duyệt" },
  { value: "Đã duyệt", label: "Đã duyệt" },
];
